module.exports = __webpack_public_path__ + "img/u-food2.1b580d27.jpg";